import { useQuery } from "@tanstack/react-query";
import {
  getDriverActivities,
  getDriverActivitiesLookup,
} from "src/services/driverActivitiesService";

export const useDriverActivitiesLookup = (
  params: Record<string, unknown>,
  enabled = true,
) =>
  useQuery({
    queryKey: ["driver-activities-lookup", params],
    queryFn: () => getDriverActivitiesLookup(params),
    enabled,
    staleTime: 60 * 60 * 1000,
    retry: false,
  });

export const useDriverActivities = (
  params: Record<string, unknown>,
  enabled = true,
) =>
  useQuery({
    queryKey: ["driver-activities", params],
    queryFn: () => getDriverActivities(params),
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
  });
